import { IAttachmentDocument } from './attachment-document.model';
import { EntityId } from './base';
import { AnnouncementPriority, AnnouncementStatus, AnnouncementType } from './enumerations';
export interface IAnnouncementRequest {
  id?: any;
  templateId?: ITemplateFile;
  startDate?: any;
  endDate?: any;
  messageTitle?: string;
  messageSummary?: string;
  messageDetail?: string;
  status?: AnnouncementStatus;
  attachments?: IAttachmentDocument[];
  colorTitle?: string;
  publishStatus: string;
}

export interface ITemplateFile {
  id?: any;
  name?: string;
  type?: string;
  smallDocumentId: string;
  largeDocumentId: string;
  mediumDocumentId: string;
}

export interface IAnnouncement {
  id?: EntityId;
  type?: AnnouncementType;
  priority?: AnnouncementPriority;
  createdDate?: number;
  startDate?: number;
  endDate?: number;
  messageTitle?: string;
  messageSummary?: string;
  thumbnail?: string;
  status?: AnnouncementStatus;
  isEnabled?: boolean;
  messageDetail?: string;
  template?: ITemplateFile;
  attachments?: IAttachmentDocument[];
  publishStatus?: string;
}

export interface IAnnouncementRequestForm {
  id?: any;
  template?: ITemplateFile;
  startDate?: any;
  endDate?: any;
  messageTitle?: string;
  messageSummary?: string;
  messageDetail?: string;
  status?: AnnouncementStatus;
  attachments?: IAttachmentDocument[];
  colorTitle?: string;
  publishStatus?: string;
}

export class AnnouncementRequestForm implements IAnnouncementRequestForm {
  constructor(
    public id?: any,
    public template?: ITemplateFile | null,
    public startDate?: any,
    public endDate?: any,
    public messageTitle?: string,
    public messageSummary?: string,
    public messageDetail?: string,
    public status?: AnnouncementStatus,
    public attachments?: IAttachmentDocument[],
    public colorTitle?: string,
    public publishStatus?: string,
  ) {
    this.id = id ? id : null;
    this.template = template ? template : null;
    this.startDate = startDate ? startDate : null;
    this.endDate = endDate ? endDate : null;
    this.messageTitle = messageTitle ? messageTitle : '';
    this.messageDetail = messageDetail ? messageDetail : '';
    this.status = status ? status : AnnouncementStatus.UNPIN;
    this.attachments = attachments ? attachments : [];
    this.colorTitle = colorTitle ? colorTitle : '';
    this.publishStatus = publishStatus ? publishStatus : '';
  }
}
